import { useQuery } from "@tanstack/react-query";
import { useTRPC } from "@/trpc";
import type { RouterOutputs } from "@/trpc";

export type OrgApprovedTimeEntry =
  RouterOutputs["timeEntry"]["getApprovedTimeEntriesForOrg"][number];

export interface ApprovedTimeEntryFilters {
  weekKey?: string;
  facilityId?: string;
  providerSearch?: string;
}

/**
 * Hook to fetch approved (historical) time entries for organization review.
 * Returns entries that have been approved for the selected business unit.
 */
export function useApprovedTimeEntries(
  organizationBusinessUnitId: string | undefined,
  filters: ApprovedTimeEntryFilters = {},
) {
  const trpc = useTRPC();

  const {
    data: entries,
    isLoading,
    error,
    refetch,
  } = useQuery(
    trpc.timeEntry.getApprovedTimeEntriesForOrg.queryOptions(
      {
        organizationBusinessUnitId: organizationBusinessUnitId!,
        weekKey: filters.weekKey,
        facilityId: filters.facilityId,
        providerSearch: filters.providerSearch,
      },
      {
        enabled: !!organizationBusinessUnitId,
      },
    ),
  );

  return {
    entries: entries ?? [],
    isLoading,
    error,
    refetch,
  };
}
